import $ from '@modules/jquery-import';

$.fn.tabs = function ( opt ) {

    var defaults = {
            controls: '.tabNavigation',
            panel: '.tabPanel',
            active_class: 'current',
            enable_hash: false,
            set_height: false,
            active_tab: null,
            effect: null
        },
        opt = $.extend( defaults, opt ),
        results = {};

    $( this ).each( function () {
        var $this = $( this ),
            control = $this.find( opt.controls ),
            tabPanel = $this.find( opt.panel ),
            tabs = tabPanel.children(),
            active_class = opt.active_class;

        function get_index ( tab_name ) {
            return tabs.index( tabs.filter( '[data-tab="' + tab_name + '"]' ) );
        };

        function reset ( e ) {
            e.stopPropagation();

            var tab_name = control.find( '*[data-tab]:first' ).attr( 'data-tab' );
            control.trigger( {
                type: 'change:tabs',
                tab_name: tab_name,
                index: get_index( tab_name )
            } );
        };

        control.on( 'click', 'li', function ( e ) {
            e.preventDefault();

            var target = $( this ),
                tab_name = target.data( 'tab' );

            // fire custom event to change tab by name
            control.trigger( {
                type: 'change:tabs',
                tab_name: tab_name,
                index: get_index( tab_name )
            } );
        } );

        if ( opt.effect == 'slider' ) {
            // add a slider effect
            tabPanel.slider( control, 'change:tabs' );
        }

        $this.on( 'reset', reset );

        // update active tab tabPanel
        control.bind( 'change:tabs', function ( e ) {
            e.stopPropagation();
            control.find( 'li.' + active_class ).removeClass( active_class );
            control.find( '[data-tab="' + e.tab_name + '"]' ).addClass( active_class );
        } );

        // change tab
        control.bind( 'change:tabs', function ( e ) {
            e.stopPropagation();
            tabPanel.find( '[data-tab]' ).removeClass( active_class );
            tabPanel.find( '[data-tab="' + e.tab_name + '"]' ).addClass( active_class );
        } );

        if ( opt.set_height ) {
            control.bind( 'change:tabs', function ( e ) {
                // set height of tabPanel to current tab
                e.stopPropagation();
                tabPanel.css( {
                    height: tabPanel.find( '[data-tab="' + e.tab_name + '"]' ).height()
                } );
            } );
        }

        if ( opt.enable_hash ) {
            control.bind( 'change:tabs', function ( e ) {
                e.stopPropagation();
                window.location.hash = e.tab_name;
            } );

            // change tab when a new hash is applied
            $( window ).bind( 'hashchange', function ( e ) {
                var tab_name = window.location.hash.slice( 1 );
                control.trigger( {
                    type: 'change:tabs',
                    tab_name: tab_name,
                    index: get_index( tab_name )
                } );
            } );
        }

        // activate first tab
        var active_tab_name = control.find( '[data-tab="' + opt.active_tab + '"]' );
        active_tab_name = (typeof active_tab_name[0] !== 'undefined') ?
            active_tab_name.attr( 'data-tab' ) :
            control.find( '[data-tab]:first' ).attr( 'data-tab' );

        control.trigger( {
            type: 'change:tabs',
            tab_name: active_tab_name,
            index: get_index( active_tab_name )
        } );
        results[this.id] = control;
    } );

    return results;
};
